import React, { useEffect, useRef } from 'react';
import dynamic from 'next/dynamic';
import { type LottieRefCurrentProps } from 'lottie-react';
import animation from 'public/lotties/semantic-html.json';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

interface LottieProp {
  animate?: boolean;
}

const LottieContainer: React.FC<LottieProp> = ({ animate }) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    if (animate) {
      lottieRef.current?.play();
    }
  }, [animate]);

  return <Lottie lottieRef={lottieRef} animationData={animation} loop={false} autoplay={false} />;
};

export default LottieContainer;
